export const getBaseURL = () => {
    let url
    if (import.meta.env.MODE === "production") {
        url = window.location.protocol + '//' + import.meta.env.VITE_BASE_URL;
    } else {
        url = import.meta.env.VITE_BASE_URL;
    }
    return url;
}

export const getFrontendUrl = () => {
    const tenant = window.location.pathname.split('/')[1];
    let url
    if (import.meta.env.MODE === "production") {
        url = window.location.protocol + '//' + import.meta.env.VITE_FRONTEND_URL + "/" + tenant;
    } else {
        url = import.meta.env.VITE_FRONTEND_URL + "/" + tenant;
    }
    return url;
}

export const getBaseFrontendUrl = () => {
    let url
    if (import.meta.env.MODE === "production") {
        url = window.location.protocol + '//' + import.meta.env.VITE_FRONTEND_URL;
    } else {
        url = import.meta.env.VITE_FRONTEND_URL;
    }
    return url;
}
